import { render, staticRenderFns } from "./OurLeaderCreate.vue?vue&type=template&id=1cb6449b&"
import script from "./OurLeaderCreate.vue?vue&type=script&lang=js&"
export * from "./OurLeaderCreate.vue?vue&type=script&lang=js&"
import style0 from "./OurLeaderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports